import router from '@/router'
import store from '@/store'

import {isMobileBrowser , isWeiXin} from '@/utils/index'
import { getUserToken , getWxConfigType , getWxConfigId ,getScanUrl ,getServicerCode ,getInviteInfo , getWxAllianceCode ,getWxAgentCode ,getMobileWebAppSource,getWeixinServicerHomePage} from '@/store/cookie'
import { Common } from '@/const/common'

// 不重定向白名单
const noUserWhiteList = ['/bind/authCheck','/customerInvite','/bind/bindPhone','/bind/bindAccount','/passwordForgetMob','/passwordForget','/inviteFailed']
const registerWhiteList=['/register','/companyInvite'];
const baseUrl =  process.env.BASE_API
// const noUserTypeWhiteList = ['/userComplete','/registerVersion','/companyVersion','/companySearch','/companyJoin','/companyCreate'] 
router.beforeEach((to, from, next) => {

  //如果已经登录
  let topath = to.path
  let user_detail = store.getters.user_detail
  let user_token = getUserToken()

  //如果是代理邀请注册公司 及公司邀请人员加入 清除原用户信息
  if( registerWhiteList.includes(topath) ){
     store.dispatch('EmptyUserDetail')
  }
 
  if (user_detail && user_detail.hasOwnProperty('user')) {
    //如果用户缺少手机号或者姓名 跳转到实例页面
    if(!user_detail.user.name || (!user_detail.account.mobile &&  parseInt(user_detail.account.is_check_mobile)==1  ) ){
        
        let sourceCode = getMobileWebAppSource()
        //如果是微校来源不需要完善手机号
        if( sourceCode &&  Common.MobileWebApp_Source.WEIXIAO ==parseInt(sourceCode) ){
             next()
            return
        }else{
            if(topath == '/userComplete' ){
              next()
              return
            }else{
              next({ path: '/userComplete' })
              return
            }
        }

    }

    // //user_type = 0 并且（公司为空或者或者没有从指定公众号进来）
    // if(user_detail.user.user_type == 0 && !user_detail.company &&!getServicerCode() ){
    //     if(noUserTypeWhiteList.includes(topath)){
    //       next()
    //     }else{
    //       next()
    //     }
    // }else{
         //登录访问绑定相关页面 跳转 
      if (noUserWhiteList.includes(topath)){
        //如果已登录扫码到authCheck可以通过
        if(topath=='/bind/authCheck' || topath=='/customerInvite' || topath=='/inviteFailed'){
           next()
           return
        }else{
          if(getWeixinServicerHomePage()&&parseInt(getWeixinServicerHomePage())===1){
            next({ path: '/bxgj/home' })
          }else{
            next({ path: '/bxgj/orderCreate' })
          }
        }
      } else {
        //如果是正常用户 如果存在扫码信息 跳转到扫码确认页
        let scanUrl = getScanUrl()
        let inviteInfo = getInviteInfo()
        if(scanUrl){
            //php
            if(topath!='/scanConfirm'){
                next({ path: '/scanConfirm' })
                return
            }
        }
        if(inviteInfo){
            if(topath != '/inviteUser')
            {
              //追回联盟
              let allianceCode = getWxAllianceCode()
              let agentCode = getWxAgentCode()
              window.location.href = baseUrl + 'relation/gateway?user_id=' + user_detail.user.id + '&account=' + user_detail.account.account + '&mobile=' + user_detail.account.mobile + '&alliance_code=' + allianceCode + '&agent_code=' + agentCode
            }
        }
        next()
      }
    // }
   
  } else {
    //无登录态路由白名单 
    
    if(user_token == '' || !user_token){
      
      //判断浏览器类型 
      if(isWeiXin()){
        console.log("is wx")
        //如果是微信
        if(topath == '/bind/authCheck'|| registerWhiteList.includes(topath) ){
          next()
        }else{
           next({ path: '/bind/authCheck'})
        }
      }else{
        //如果不是微信
        if (noUserWhiteList.includes(topath)|| registerWhiteList.includes(topath)){
          next()
        } else {
          //如果不在白名单
          if(topath!='/bind/bindPhone'){
            next({ path:'/bind/bindPhone'})
          }else{
            next()
          }
        }
      }
    }else{
       if (noUserWhiteList.includes(topath)|| registerWhiteList.includes(topath)){
          next()
        } else {
          next({ path: '/bind/authCheck'})
        }
    }
    
  }
})

router.afterEach(() => {
    //结束Progress

})



// WEBPACK FOOTER //
// ./src/router/check.js